// import React, { useState } from "react";

interface ToggleSwitchProps {
  isActive?: boolean;
  onChange?: (e: any) => void;
  ariaLabel?: string;
  title?: string;
  className?: string;
  item?: any;
}

const CToggleSwitch: React.FC<ToggleSwitchProps> = ({
  isActive,
  onChange,
  ariaLabel = "Toggle switch",
  title,
  className = "",
  item,
}) => {
  // const [isActive, setIsActive] = useState(initialActive);

  // useEffect(() => {
  //   setIsActive(initialActive);
  // }, [initialActive]);

  const handleToggle = () => {
    const newState = !isActive;
    console.log('item', item)
    // setIsActive(newState);
    if (onChange) {
      const dataChange = {state: newState, item: item}
      onChange(dataChange);
    }
  };

  return (
    <article className={`flex justify-between items-center px-0 py-2.5  h-[52px] max-sm:px-0 max-sm:py-2.5 ${className}`}>
      <p className="text-[14px] font-medium tracking-tighter text-neutral-900">
        {title}
      </p>
      <button
        type="button"
        role="switch"
        aria-checked={isActive}
        aria-label={ariaLabel}
        className={`relative px-1 py-0.5 h-8 cursor-pointer bg-zinc-900 bg-opacity-10 rounded-[100px] w-[52px] ${isActive ? " !bg-[#FF6741]" : ""}`}
        onClick={handleToggle}
      >
        <span
          className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-3xl transition-transform duration-[0.2s] ${isActive ? "translate-x-5" : ""
            }`}
        />
      </button>
    </article>
  );
};

export default CToggleSwitch;